import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from 'sweetalert2';
import "../scss/card.css"
import { CModal } from '@coreui/react';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const CompetitiveExamSubtopicMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const initialFormState = {
        competitiveExamNameMasterId: '',
        competitiveLessonMasterId: '',
        competitiveTopicMasterId: '',
        competitiveSubTopicName: '',
        details: '',
        competitiveExamBookMasterId: '',
        subjectMasterId: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [bookList, setBookList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [examNameSort, setExamNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);
    const [subtopicNameSort, setSubtopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["competitiveExamNameMasterDetails.examName", "competitiveExamBookMasterDetails.bookName", "subjectMasterDetails.subjectName", "competitiveLessonMasterDetails.competitiveLessonName", "competitiveTopicMasterDetails.competitiveTopicName", "competitiveSubTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (subtopicData.competitiveExamNameMasterId !== '' && subtopicData.competitiveExamBookMasterId !== '' && subtopicData.subjectMasterId !== '') {
                let apiUrl = '/get-competitive-sub-topic?';

                if (subtopicData.competitiveExamNameMasterId) {
                    apiUrl += `competitiveExamNameMasterId=${subtopicData.competitiveExamNameMasterId}&`;
                }

                if (subtopicData.subjectMasterId) {
                    apiUrl += `subjectMasterId=${subtopicData.subjectMasterId}&`
                }

                if (subtopicData.competitiveExamBookMasterId) {
                    apiUrl += `competitiveExamBookMasterId=${subtopicData.competitiveExamBookMasterId}&`
                }

                if (subtopicData.competitiveLessonMasterId) {
                    apiUrl += `competitiveLessonMasterId=${subtopicData.competitiveLessonMasterId}&`;
                }

                if (subtopicData.competitiveTopicMasterId) {
                    apiUrl += `competitiveTopicMasterId=${subtopicData.competitiveTopicMasterId}&`;
                }

                apiUrl = apiUrl.replace(/&$/, '');
                setSubtopicList(await searchArray("A", apiUrl, searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (subtopicData.competitiveExamNameMasterId !== '' && subtopicData.competitiveExamBookMasterId !== '' && subtopicData.subjectMasterId !== '') {
            let apiUrl = '/get-competitive-sub-topic?';

            if (subtopicData.competitiveExamNameMasterId) {
                apiUrl += `competitiveExamNameMasterId=${subtopicData.competitiveExamNameMasterId}&`;
            }

            if (subtopicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${subtopicData.subjectMasterId}&`
            }

            if (subtopicData.competitiveExamBookMasterId) {
                apiUrl += `competitiveExamBookMasterId=${subtopicData.competitiveExamBookMasterId}&`
            }

            if (subtopicData.competitiveLessonMasterId) {
                apiUrl += `competitiveLessonMasterId=${subtopicData.competitiveLessonMasterId}&`;
            }

            if (subtopicData.competitiveTopicMasterId) {
                apiUrl += `competitiveTopicMasterId=${subtopicData.competitiveTopicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            // Make the API call
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result);
                    // console.log('Data:', response.data);
                })
                .catch(error => {
                    setSubtopicList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [subtopicData, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subtopicList.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-competitive-exam-names`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }

    const getTopicList = (id) => {
        const apiUrl = `/get-competitive-topic?competitiveLessonMasterId=${id}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getSubtopicList = () => {
        if (subtopicData.competitiveExamNameMasterId !== '' && subtopicData.competitiveExamBookMasterId !== '' && subtopicData.subjectMasterId !== '') {
            // Construct the API URL when syllabusData changes
            let apiUrl = '/get-competitive-sub-topic?';

            if (subtopicData.competitiveExamNameMasterId) {
                apiUrl += `competitiveExamNameMasterId=${subtopicData.competitiveExamNameMasterId}&`;
            }

            if (subtopicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${subtopicData.subjectMasterId}&`
            }

            if (subtopicData.competitiveExamBookMasterId) {
                apiUrl += `competitiveExamBookMasterId=${subtopicData.competitiveExamBookMasterId}&`
            }

            if (subtopicData.competitiveLessonMasterId) {
                apiUrl += `competitiveLessonMasterId=${subtopicData.competitiveLessonMasterId}&`;
            }

            if (subtopicData.competitiveTopicMasterId) {
                apiUrl += `competitiveTopicMasterId=${subtopicData.competitiveTopicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result)
                    // console.log('Data:', response.data);
                    setAddNew(!addNew);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log(errorMsg)
                });
        }
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
            }
        })
    }

    const handleDetailChange = (editor) => {
        let value = editor.getData();
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                // details: `<style>.ckContent img{max-width:100% !important}</style><div class="ckContent"> ${value}  </div>`
                details: value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveExamBookMasterId: "",
                competitiveLessonMasterId: '',
                competitiveTopicMasterId: '',
                subjectMasterId: ''
            }
        })

        const apiUrl2 = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setBookList(response.data.data)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleBookChanges = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
                competitiveLessonMasterId: '',
                competitiveTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChanges = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveLessonMasterId: '',
                competitiveTopicMasterId: '',
                // competitiveSubTopicName:'',
            }
        })

        const apiUrl = `/get-competitive-lesson?competitiveExamBookMasterId=${subtopicData.competitiveExamBookMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                setLessonList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }


    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveTopicMasterId: ''
            }
        })
        const apiUrl = `/get-competitive-topic?competitiveLessonMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(subtopicData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };


    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [subtopicData])

    const addTopic = () => {
        const apiUrl = `/add-competitive-sub-topic`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, subtopicData)
                .then(response => {
                    getSubtopicList();
                    setSubtopicData((prevData) => {
                        return {
                            ...prevData,
                            competitiveSubTopicName: '',
                            details: ''
                        }
                    })

                    setSaveId(response.data.result[0].id);
                    setExamNameSort(null);
                    setBookNameSort(null);
                    setSubjectNameSort(null);
                    setLessonNameSort(null);
                    setTopicNameSort(null);
                    setSubtopicNameSort(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(subtopicData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const reset = () => {
        setSubtopicData(initialFormState);
        setSubtopicList([])
        setEditId('')
    }

    const deleteSubtopic = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-competitive-sub-topic?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, subtopicList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateSubtopic = () => {
        setLoading(true);
        const apiUrl = `/edit-competitive-sub-topic?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, subtopicData)
            .then(response => {
                getSubtopicList();
                setSaveId(response.data.result.id);
                setEditId(null);
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        competitiveSubTopicName: '',
                        details: ''
                    }
                })
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err.data.message);
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setExamNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubtopicNameSort(null);
        }
    }, [bookNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubtopicNameSort(null);
        }
    }, [subjectNameSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
            setTopicNameSort(null);
            setSubtopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setSubtopicNameSort(null);
        }
    }, [topicNameSort])

    useEffect(() => {
        if (subtopicNameSort == true || subtopicNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [subtopicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <div id='scroll-up'></div>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Subtopic Master</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-info"></i>Competitive Exam Subtopic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam  Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveExamNameMasterId' onChange={handleSyllabusChange} value={subtopicData.competitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam  Structure</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.competitiveExamNameMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveExamBookMasterId' onChange={handleBookChanges} value={subtopicData.competitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveExamBookMasterId && <p style={{ color: 'red' }}>{error.competitiveExamBookMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChanges} value={subtopicData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveLessonMasterId' onChange={handleLessonChange} value={subtopicData.competitiveLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.competitiveLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveLessonMasterId && <p style={{ color: 'red' }}>{error.competitiveLessonMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveTopicMasterId' onChange={handleInputChange} value={subtopicData.competitiveTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.competitiveTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveTopicMasterId && <p style={{ color: 'red' }}>{error.competitiveTopicMasterId}</p>}

                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Sub Topic Name :</label>
                                                    <input required type="text" className="form-control" id="competitiveSubTopicName" name='competitiveSubTopicName' onChange={handleInputChange} value={subtopicData.competitiveSubTopicName} />
                                                    {error.competitiveSubTopicName && <p style={{ color: 'red' }}>{error.competitiveSubTopicName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Sub Topic Details :</label>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={subtopicData.details}
                                                        onReady={editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            // console.log('Editor is ready to use!', editor);
                                                        }}
                                                        onChange={(event, editor) => {
                                                            // console.log(event)
                                                            handleDetailChange(editor)
                                                        }}

                                                        config={{
                                                            extraPlugins: [uploadPlugin],
                                                        }}

                                                        onInit={(editor) => {
                                                            // Register the custom upload adapter
                                                            uploadPlugin(editor);
                                                        }}
                                                    />
                                                    {error.details && <p style={{ color: 'red' }}>{error.details}</p>}

                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTopic}>Save</button>
                                                        }                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={reset}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSubtopic} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <div className='table-header-like'> Sub Topic Details</div>
                                                        <div className="page" dangerouslySetInnerHTML={{
                                                            __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                                                        }}></div>
                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope='col'>
                                                                            Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterDetails.examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Name
                                                                            <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveExamBookMasterDetails.bookName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveLessonMasterDetails.competitiveLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveTopicMasterDetails.competitiveTopicName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Sub Topic Name
                                                                            <SortIcon sortState={subtopicNameSort} setSortState={setSubtopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveSubTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((subtopic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{subtopic?.competitiveExamNameMasterDetails?.examName}</td>
                                                                                        <td>{subtopic?.competitiveExamBookMasterDetails?.bookName}</td>
                                                                                        <td>{subtopic?.subjectMasterDetails?.subjectName}</td>
                                                                                        <td>{subtopic?.competitiveLessonMasterDetails?.competitiveLessonName}</td>
                                                                                        <td>{subtopic?.competitiveTopicMasterDetails?.competitiveTopicName}</td>
                                                                                        <td>{subtopic?.competitiveSubTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                getTopicList(subtopic.competitiveTopicMasterId);
                                                                                                setSubtopicData({
                                                                                                    // subTopicNo: subtopic.subTopicNo,
                                                                                                    details: subtopic.details,
                                                                                                    competitiveSubTopicName: subtopic.competitiveSubTopicName,
                                                                                                    competitiveLessonMasterId: subtopic.competitiveLessonMasterId,
                                                                                                    competitiveTopicMasterId: subtopic.competitiveTopicMasterId,
                                                                                                    // competitiveExamNameMasterId: subtopic.subTopicMasterSyllabusStructureMasterDetails?.id,
                                                                                                    competitiveExamBookMasterId: subtopic.competitiveExamBookMasterId
                                                                                                });
                                                                                                setEditId(subtopic.id);
                                                                                                // setTopicList([{
                                                                                                //     id: subtopic.competitiveTopicMasterId,
                                                                                                //     competitiveTopicName: subtopic.competitiveTopicMasterDetails?.competitiveTopicName
                                                                                                // }]);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setVisible(!visible)
                                                                                                setModalData(subtopic.details)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === subtopic.id} onClick={() => deleteSubtopic(subtopic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Sub Topic Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default CompetitiveExamSubtopicMaster;